module.exports = __webpack_public_path__ + "img/projectplanning.b162169e.svg";